import GooglePlaces from './GooglePlaces';
import geocodeByAddress from './utils/geocodeByAddress';
import geocodeByPlaceId from './utils/geocodeByPlaceId';

export {
  geocodeByAddress,
  geocodeByPlaceId,
};
export default GooglePlaces;
